import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Location: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      {/* Page Header with Image */}
      <div className="relative text-white py-24 mt-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=1920&h=600&fit=crop&q=80"
            alt="Location"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>

        <div className="max-w-6xl mx-auto px-8 relative z-10">
          <p className="text-gray-200 mb-3 text-sm font-medium tracking-wider">센터소개</p>
          <h1 className="text-5xl md:text-6xl font-bold mb-4">오시는 길</h1>
          <div className="w-20 h-1 bg-white/70"></div>
        </div>
      </div>

      {/* Location & Access Section - White Background */}
      <div className="flex-1 py-20 bg-white">
        <div className="max-w-6xl mx-auto px-8">
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <span className="text-3xl">📍</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
              오시는 길
            </h2>
            <p className="text-gray-600">Location & Access</p>
          </div>

          {/* 주소 및 건물명 */}
          <div className="bg-gradient-to-br from-green-50 to-white border border-gray-200 rounded-2xl p-8 mb-12 text-center">
            <h3 className="text-2xl md:text-3xl font-bold text-green-600 mb-4">
              동두천 싸이언스타워
            </h3>
            <p className="text-lg text-gray-700">
              경기도 동두천시 동두천로 97<br />
              (경기도 동두천시 지행동 722-3)
            </p>
          </div>

          {/* 지도 이미지 */}
          <div className="mb-12">
            <img
              src="/오시는길 사진.png"
              alt="오시는 길 지도"
              className="w-full max-w-4xl mx-auto rounded-2xl shadow-lg"
            />
          </div>

          {/* 교통편 안내 */}
          <div className="grid md:grid-cols-3 gap-8">
            {/* 버스 */}
            <div className="bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="text-center mb-4">
                <span className="text-5xl">🚌</span>
                <h3 className="text-xl font-bold text-gray-800 mt-4 mb-2">버스로 오시는 경우</h3>
              </div>
              <div className="space-y-3 text-sm text-gray-700">
                <p className="text-xs text-gray-500">
                  ※ 경기도 동두천시 동두천로 97<br />
                  (동두천시 지행동 722-3) 주변<br />
                  실제 정류장 기준
                </p>
                <div className="pt-2">
                  <p className="font-semibold text-green-600 mb-1">✅ 지행역·동두천시청·지행동 일대</p>
                  <p className="leading-relaxed">
                    <span className="font-medium">주요 버스:</span><br />
                    3-2, 3-4, 4, 3, 39, 53번 등
                  </p>
                  <p className="text-gray-600 mt-2">
                    → 지행역 정류장 이용 가능<br />
                    (도보 3~7분)
                  </p>
                </div>
              </div>
            </div>

            {/* 지하철 */}
            <div className="bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="text-center mb-4">
                <span className="text-5xl">🚉</span>
                <h3 className="text-xl font-bold text-gray-800 mt-4 mb-2">지하철로 오시는 경우</h3>
              </div>
              <div className="space-y-3 text-sm text-gray-700">
                <div>
                  <p className="font-semibold text-green-600 mb-2">수도권 전철 1호선</p>
                  <div className="space-y-1.5 leading-relaxed">
                    <p>
                      <span className="font-medium">하차역:</span> 지행역
                    </p>
                    <p>
                      <span className="font-medium">출구:</span> 1번 출구
                    </p>
                    <p className="text-green-600 font-semibold mt-3">
                      도보 5분 거리
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 자가용 */}
            <div className="bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="text-center mb-4">
                <span className="text-5xl">🚗</span>
                <h3 className="text-xl font-bold text-gray-800 mt-4 mb-2">자가용 이용 시</h3>
              </div>
              <div className="space-y-3 text-sm text-gray-700">
                <div>
                  <p className="font-semibold text-green-600 mb-2">📍 네비게이션 주소</p>
                  <p className="leading-relaxed bg-gray-50 p-3 rounded-lg text-xs">
                    경기도 동두천시 동두천로 97<br />
                    (동두천시 지행동 722-3)
                  </p>
                </div>
                <div className="pt-2">
                  <p className="font-semibold mb-2">주요 접근 경로</p>
                  <ul className="space-y-1.5 leading-relaxed">
                    <li>• 의정부 → 3번 국도 북상<br />→ 지행역 사거리 우회전</li>
                    <li>• 양주 → 동두천 시내 진입<br />→ 지행역 방면</li>
                  </ul>
                  <p className="text-gray-600 mt-3 text-xs">
                    건물 주변 공영주차장/<br />노상주차장 이용
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="py-20 text-white relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=1920&h=600&fit=crop&q=80"
            alt="Welcome"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-green-700/90 to-teal-800/90"></div>
        </div>

        <div className="max-w-6xl mx-auto px-8 relative z-10">
          <div className="text-center">
            <div className="inline-block mb-6">
              <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                <span className="text-2xl">🎓</span>
                <span className="font-semibold text-lg">Visit Us</span>
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 leading-relaxed">
              동두천시 글로벌인재교육센터에서<br />
              새로운 배움을 시작하세요
            </h2>
            <p className="text-xl text-green-100 max-w-3xl mx-auto leading-relaxed">
              편리한 교통과 최신 시설이 준비되어 있습니다
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Location;
